import { Cacheable } from "cacheable";

const GLOBAL_CACHE_TTL = "5m";

const cache = new Cacheable({ ttl: GLOBAL_CACHE_TTL });

export default cache;
